import { Status } from '../models/CommonModels';
import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useWmsTerminalCommonStore: any = defineStore('wmsTerminalCommonStore', () => {
  const status = ref<Status>(new Status());

  function setStatus(newStatus: Status) {
    status.value = newStatus;
  }

  return {
    status,
    setStatus,
  };
});
